import React from 'react';
import ReactDOM from 'react-dom';
import {createFragmentContainer, QueryRenderer} from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { Route, Link } from "react-router-dom";

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';

import NavDrawer from '../../StorybookComponents/NavDrawer';

import withTheme, {theme} from '../../themes/app_theme';

import RoutesComponent from './RoutesComponent';
import environment from '../../mock_environment';
import ErrorPage from '../../adminComponent/ErrorPage';

const menu = [
  {
    to: '/',
    path: '/',
    title: 'Properties',
    icon_type: 'icon-apartment'
  },
  {
    to: '/embeds',
    path: '/embeds',
    title: 'Embeds',
    icon_type: 'icon-floors'
  },
  {
    to: '/tracking',
    path: '/tracking',
    title: 'Tracking',
    icon_type: 'icon-timeline'
  },
  {
    to: '/subscriptions',
    path: '/subscriptions',
    title: 'Subscriptions',
    icon_type: 'icon-multiple-11'
  }
]

const NavDrawerComponent = createFragmentContainer(
  React.memo(({
    account: {
      first_name,
      last_name,
      org: { id: org_id, name: org },
      authorizedApps,
      ...account
    },
    pathname,
    children
  }) => {

  console.log("first_name: ",first_name)
  const accountsPermissions = Boolean(authorizedApps.find(
    ({ name, access }) => name === "Accounts" && access === "admin"
  ));

  const navDrawerMenu = accountsPermissions
    ? [
        ...menu,
        {
          to: '/accounts',
          path: '/accounts',
          title: 'Accounts',
          icon_type: 'icon-single-02'
        }
      ]
    : menu;

  return (
    <NavDrawer
        user = {{
          ...account,
          property: '',
          name: `${first_name} ${last_name}`,
          org_id,
          org
        }}
        pathname={pathname}
        environment = {environment}
        suborg_change_available
        link_component = {Link}
        menu = {navDrawerMenu}
    >
    {
      React.cloneElement(
        children,
        {
          authorization: {
            accounts: accountsPermissions
          }
        }
      )
    }
  </NavDrawer>
 )
}),
{
  account: graphql`
    fragment AccountsNavDrawer_account on Account {
        first_name
        last_name
        org {
          id
          name
        }
        authorizedApps {
          name
          access
        }
    }
  `
 }
)

export default React.memo(other_props => (
  <QueryRenderer
    environment={environment}
    query={graphql`
      query AccountsNavDrawerQuery(
        $accountID: ID!
      ) {
        account (id: $accountID) {
          ...AccountsNavDrawer_account
        }
      }
    `}
    variables = {{ accountID: "123" }}
    render={({ error, props }) => {
      return error
        ? <ErrorPage />
        : props
        ? <NavDrawerComponent account = {props.account} {...other_props}/>
        : <div>loading...</div>
    }}
  />

));
